export default {
	horizontal: [''],
	vertical: ['divider--vertical'],
	'horizontal-full-width': ['divider--full-width']
};
